// SalesPage.js
import React from 'react';
import styles from './SalesAndMarketing.module.css';

function SalesMarketing() {
  return (
    <div className={styles.pageWrapper}>
      {/* AI-POWERED PLATFORM BADGE */}
      <div className={styles.badge}>
        <svg
          className={styles.badgeIcon}
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M9.8 17.5l-2.7 1.8c-.7.5-1.6.5-2.3 0L2 17.5C1.3 17 1 16.1 1 15.2V8.8C1 7.9 1.3 7 2 6.5l2.8-1.8c.7-.5 1.6-.5 2.3 0l2.7 1.8c.7.5 1 1.4 1 2.3v10.4c0 .9-.3 1.8-1 2.3z" />
          <path d="M14 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
        </svg>
        AI-Powered Platform
      </div>

      {/* MAIN HEADLINE */}
      <h1 className={styles.mainTitle}>
        AI Agents for <br />
        <span className={styles.gradientText}>Sell More</span>
        <span className={styles.gradientText2}>Reach 1 Billion+</span>
      </h1>

      {/* PREVIEW BUTTON */}
      <button className={styles.previewBtn}>Preview</button>

      {/* SUBTITLE */}
      <p className={styles.subtitle}>
        Transform your sales process with AI-powered agents that help you reach millions of potential customers. Scale your business effortlessly with intelligent automation.
      </p>

      <div className={styles.finalHeroButtons}>
          <button className={styles.gettingStartedBtn}>Getting Started</button>
          <button className={styles.learnMoreBtn}>Learn More</button>
        </div>

        <div className={styles.statsGrid}>
          {/* Stat 1 */}
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>20%</h2>
            <p className={styles.statLabel}>Increase in Sales</p>
          </div>

          {/* Stat 2 */}
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>40%</h2>
            <p className={styles.statLabel}>Cost Reduction</p>
          </div>

          {/* Stat 3 */}
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>60%</h2>
            <p className={styles.statLabel}>Time Saved</p>
          </div>

          {/* Stat 4 */}
          <div className={styles.statCard}>
            <h2 className={styles.statNumber}>99%</h2>
            <p className={styles.statLabel}>Accuracy Rate</p>
          </div>
          </div>

      {/* DATA CENTRE SECURITY SECTION */}
      <section className={styles.dataCentreSection}>
        <div className={styles.dataCentreLeft}>
          <h2 className={styles.dataCentreTitle}>Your Data Centre Is More Secure</h2>
          <p className={styles.dataCentreSubtitle}>
            Our enterprise-grade security infrastructure ensures your data is protected with military-grade encryption and compliance with global security standards. Your business data remains private, secure, and under your complete control.
          </p>

          <div className={styles.bulletList}>
            <div className={styles.bulletItem}>
              <div className={styles.bulletDot}></div>
              <div>
                <strong>End-to-end Encryption</strong>
                <br />
                All data is encrypted in transit and at rest
              </div>
            </div>
            <div className={styles.bulletItem}>
              <div className={styles.bulletDot}></div>
              <div>
                <strong>SOC 2 Compliance</strong>
                <br />
                Certified secure by industry standards
              </div>
            </div>

            <div className={styles.bulletItem}>
              <div className={styles.bulletDot}></div>
              <div>
                <strong>Regular Security Audits</strong>
                <br />
                Continuous monitoring and improvement
              </div>
            </div>
          </div>
        </div>

        <div className={styles.dataCentreRight}>
          <div className={styles.securityCardGrid}>
            {/* Card 1 */}
            <div className={styles.securityCard}>
              <div className={styles.securityIconWrapper}>
                <svg
                  className={styles.securityIcon}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <h3 className={styles.securityCardTitle}>Advanced Protection</h3>
              <p className={styles.securityCardDesc}>Multi-layer security protocols</p>
            </div>

            {/* Card 2 */}
            <div className={styles.securityCard}>
              <div className={styles.securityIconWrapper}>
                <svg
                  className={styles.securityIcon}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <h3 className={styles.securityCardTitle}>Data Privacy</h3>
              <p className={styles.securityCardDesc}>GDPR & CCPA compliant</p>
            </div>

            {/* Card 3 */}
            <div className={styles.securityCard}>
              <div className={styles.securityIconWrapper}>
                <svg
                  className={styles.securityIcon}
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <ellipse cx="12" cy="5" rx="9" ry="3" />
                  <path d="M3 5V19A9 3 0 0 0 21 19V5" />
                  <path d="M3 12A9 3 0 0 0 21 12" />
                </svg>
              </div>
              <h3 className={styles.securityCardTitle}>Backup Systems</h3>
              <p className={styles.securityCardDesc}>Redundant, automated backups</p>
            </div>

            {/* Card 4 */}
            <div className={styles.securityCard}>
              <div className={styles.securityIconWrapper}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={styles.securityIcon}
                >
                  <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
                  <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
                  <line x1="6" y1="6" x2="6.01" y2="6" />
                  <line x1="6" y1="18" x2="6.01" y2="18" />
                </svg>
              </div>
              <h3 className={styles.securityCardTitle}>99.9% Uptime</h3>
              <p className={styles.securityCardDesc}>Guaranteed availability</p>
            </div>
          </div>
        </div>
      </section>

      {/* NEW: AI AGENTS FEATURES SECTION */}
      <section className={styles.agentsSection}>
        <h2 className={styles.agentsTitle}>AI Agents for Every State & Everything Else</h2>
        <p className={styles.agentsSubtitle}>
          Deploy intelligent AI agents that work 24/7 to automate your sales process, engage customers, and drive revenue growth across all channels.
        </p>
        
        <div className={styles.agentsGrid}>
          {/* Card 1 */}
          <div className={styles.agentsCard}>
            <div className={styles.agentsIconWrapper} style={{ backgroundColor: '#f0e6ff' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="purple" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bot-icon lucide-bot"><path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/></svg>
            </div>
            <h3 className={styles.agentsCardTitle}>Lead Generation</h3>
          </div>
          
          {/* Card 2 */}
          <div className={styles.agentsCard}>
            <div className={styles.agentsIconWrapper} style={{ backgroundColor: '#e6f0ff' }}>
              <svg className={styles.agentsIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="6" />
                <circle cx="12" cy="12" r="2" />
              </svg>
            </div>
            <h3 className={styles.agentsCardTitle}>Smart Targeting</h3>
          </div>
          
          {/* Card 3 */}
          <div className={styles.agentsCard}>
            <div className={styles.agentsIconWrapper} style={{ backgroundColor: '#e6ffe6' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="purple" stroke-width="2" strokeLinecap="round" stroke-linejoin="round" class="lucide lucide-trending-up-icon lucide-trending-up"><path d="M16 7h6v6"/><path d="m22 7-8.5 8.5-5-5L2 17"/></svg>
            </div>
            <h3 className={styles.agentsCardTitle}>Sales Analytics</h3>
          </div>
          
          {/* Card 4 */}
          <div className={styles.agentsCard}>
            <div className={styles.agentsIconWrapper} style={{ backgroundColor: '#fff0e6' }}>
              <svg className={styles.agentsIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M13 2L2 14h10l-1 8 10-12h-9l1-8z" />
              </svg>
            </div>
            <h3 className={styles.agentsCardTitle}>Automation</h3>
          </div>
        </div>
      </section>

            {/* WHY 21 MILLION+ DAILY USERS SECTION */}
      <section className={styles.whyUsersSection}>
        <h2 className={styles.whyUsersTitle}>Why 21 Million+ Daily Users</h2>
        <p className={styles.whyUsersSubtitle}>
          Join millions of professionals who trust Toxbox.ai to power their sales and marketing automation
        </p>
        
        <div className={styles.whyUsersGrid}>
          {/* Card 1 */}
          <div className={styles.whyUsersCard}>
            <div className={styles.whyUsersIconWrapper} style={{ backgroundColor: '#f0e6ff' }}>
              <svg className={styles.whyUsersIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
                <path d="M16 16v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1" />
                <path d="M6 12v1a2 2 0 0 1-2 2h0a2 2 0 0 1-2-2v-1" />
              </svg>
            </div>
            <h3 className={styles.whyUsersCardTitle}>Easy to Use</h3>
            <p className={styles.whyUsersCardDesc}>
              Intuitive interface designed for teams of all sizes. Get started in minutes without technical expertise.
            </p>
          </div>
          
          {/* Card 2 */}
          <div className={styles.whyUsersCard}>
            <div className={styles.whyUsersIconWrapper} style={{ backgroundColor: '#e6f0ff' }}>
              <svg className={styles.whyUsersIcon} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                <path d="M2 12h20" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
              </svg>
            </div>
            <h3 className={styles.whyUsersCardTitle}>Global Reach</h3>
            <p className={styles.whyUsersCardDesc}>
              Connect with audiences worldwide with support for 50+ languages and regional customization.
            </p>
          </div>
          
          {/* Card 3 */}
          <div className={styles.whyUsersCard}>
            <div className={styles.whyUsersIconWrapper} style={{ backgroundColor: '#e6ffe6' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="purple" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-award-icon lucide-award"><path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"/><circle cx="12" cy="8" r="6"/></svg>
            </div>
            <h3 className={styles.whyUsersCardTitle}>Proven Results</h3>
            <p className={styles.whyUsersCardDesc}>
              Our customers see an average 3x increase in qualified leads within the first 90 days.
            </p>
          </div>
        </div>
      </section>

            {/* DESIGNED TO DO AMAZING WORK SECTION */}
      <section className={styles.amazingWorkSection}>
        <h2 className={styles.amazingWorkTitle}>Designed to do Amazing Work</h2>
        <p className={styles.amazingWorkSubtitle}>
          Built with cutting-edge technology to deliver exceptional results for your business
        </p>
        
        <div className={styles.amazingWorkGrid}>
          {/* Card 1 */}
          <div className={styles.amazingWorkCard}>
            <div className={styles.amazingWorkIconWrapper} style={{ backgroundColor: '#f0e6ff' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="purple" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lightbulb-icon lucide-lightbulb"><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></svg>
            </div>
            <h3 className={styles.amazingWorkCardTitle}>Smart Insights</h3>
            <p className={styles.amazingWorkCardDesc}>
              AI-powered analytics that provide actionable insights to improve your sales performance and conversion rates.
            </p>
          </div>
          
          {/* Card 2 */}
          <div className={styles.amazingWorkCard}>
            <div className={styles.amazingWorkIconWrapper} style={{ backgroundColor: '#e6f0ff' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="purple" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layers-icon lucide-layers"><path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"/><path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"/><path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"/></svg>
            </div>
            <h3 className={styles.amazingWorkCardTitle}>Seamless Integration</h3>
            <p className={styles.amazingWorkCardDesc}>
              Connect with your existing tools and platforms effortlessly. Works with all major CRM and marketing platforms.
            </p>
          </div>
          
          {/* Card 3 */}
          <div className={styles.amazingWorkCard}>
            <div className={styles.amazingWorkIconWrapper} style={{ backgroundColor: '#e6ffe6' }}>
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="purple" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-cpu-icon lucide-cpu"><path d="M12 20v2"/><path d="M12 2v2"/><path d="M17 20v2"/><path d="M17 2v2"/><path d="M2 12h2"/><path d="M2 17h2"/><path d="M2 7h2"/><path d="M20 12h2"/><path d="M20 17h2"/><path d="M20 7h2"/><path d="M7 20v2"/><path d="M7 2v2"/><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="8" y="8" width="8" height="8" rx="1"/></svg>
            </div>
            <h3 className={styles.amazingWorkCardTitle}>Advanced AI</h3>
            <p className={styles.amazingWorkCardDesc}>
              Leverage state-of-the-art machine learning models trained on billions of data points for maximum accuracy.
            </p>
          </div>
        </div>
      </section>

            {/* THE ALL-INCLUSIVE PACKAGE SECTION */}
      <section className={styles.packageSection}>
        <h2 className={styles.packageTitle}>The All-Inclusive Package</h2>
        <p className={styles.packageSubtitle}>
          Choose the perfect plan for your business needs. All plans include our core AI features.
        </p>
        
        <div className={styles.packageGrid}>
          {/* STARTER PLAN */}
          <div className={styles.packageCard}>
            <h3 className={styles.packageName}>Starter</h3>
            <p className={styles.packageDescription}>Perfect for small teams getting started</p>
            <div className={styles.packagePrice}>
              <span className={styles.priceValue}>$49</span>
              <span className={styles.pricePeriod}>/month</span>
            </div>
            
            <ul className={styles.featureList}>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                100 AI agent interactions/day
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Basic analytics dashboard
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Email support
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                CRM integration
              </li>
            </ul>
            
            <button className={styles.packageBtn}>Get Started</button>
          </div>
          
          {/* PROFESSIONAL PLAN (MOST POPULAR) */}
          <div className={styles.packageCard} style={{ borderColor: '#8b5cf6' }}>
            <div className={styles.popularBadge}>Most Popular</div>
            <h3 className={styles.packageName}>Professional</h3>
            <p className={styles.packageDescription}>For growing businesses that need more</p>
            <div className={styles.packagePrice}>
              <span className={styles.priceValue}>$149</span>
              <span className={styles.pricePeriod}>/month</span>
            </div>
            
            <ul className={styles.featureList}>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Unlimited AI interactions
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Advanced analytics & reporting
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Priority support
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                All integrations
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Custom workflows
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                API access
              </li>
            </ul>
            
            <button className={styles.packageBtn} style={{ backgroundColor: '#8b5cf6', color: 'white' }}>
              Get Started
            </button>
          </div>
          
          {/* ENTERPRISE PLAN */}
          <div className={styles.packageCard}>
            <h3 className={styles.packageName}>Enterprise</h3>
            <p className={styles.packageDescription}>For large organizations with specific needs</p>
            <div className={styles.packagePrice}>
              <span className={styles.priceValue}>Custom</span>
            </div>
            
            <ul className={styles.featureList}>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Dedicated AI infrastructure
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                White-label options
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                24/7 phone support
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Custom integrations
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                SLA guarantee
              </li>
              <li className={styles.featureItem}>
                <span className={styles.checkmark}>✓</span>
                Dedicated account manager
              </li>
            </ul>
            
            <button className={styles.packageBtn}>Contact Sales</button>
          </div>
        </div>
      </section>

            {/* PERSONALLY AGENT SECTION */}
      <section className={styles.personallyAgentSection}>
        <h2 className={styles.personallyAgentTitle}>Tool we've Personally Agents</h2>
        <p className={styles.personallyAgentSubtitle}>
          Powerful AI agents tailored to different aspects of your sales process
        </p>

        <div className={styles.personallyAgentGrid}>
          {/* ChatAgent Card */}
          <div className={styles.personallyAgentCard}>
            <div className={styles.agentIconWrapper} style={{ backgroundColor: '#d870fa' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
            <h3 className={styles.agentCardTitle}>ChatAgent</h3>
            <p className={styles.agentCardDesc}>
              Engage customers in natural conversations, answer questions instantly, and guide them through the sales funnel 24/7.
            </p>
            <ul className={styles.agentFeatureList}>
              <li> Natural language processing</li>
              <li> Multi-channel support</li>
              <li> Sentiment analysis</li>
            </ul>
          </div>

          {/* AnalyticsAgent Card */}
          <div className={styles.personallyAgentCard}>
            <div className={styles.agentIconWrapper} style={{ backgroundColor: '#0ea5e9' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column-increasing-icon lucide-chart-column-increasing"><path d="M13 17V9"/><path d="M18 17V5"/><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M8 17v-3"/></svg>
            </div>
            <h3 className={styles.agentCardTitle}>AnalyticsAgent</h3>
            <p className={styles.agentCardDesc}>
              Get deep insights into your sales performance, identify trends, and receive AI-powered recommendations to optimize results.
            </p>
            <ul className={styles.agentFeatureList}>
              <li> Predictive analytics</li>
              <li> Custom dashboards</li>
              <li> Real-time reporting</li>
            </ul>
          </div>

          {/* LeadAgent Card */}
          <div className={styles.personallyAgentCard} style={{ border: '1px solid #a855f7', boxShadow: '0 4px 12px rgba(168, 85, 247, 0.1)' }}>
            <div className={styles.agentIconWrapper} style={{ backgroundColor: '#10b981' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-round-icon lucide-users-round"><path d="M18 21a8 8 0 0 0-16 0"/><circle cx="10" cy="8" r="5"/><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"/></svg>
            </div>
            <h3 className={styles.agentCardTitle}>LeadAgent</h3>
            <p className={styles.agentCardDesc}>
              Automatically identify, qualify, and nurture leads while prioritizing the most promising opportunities for your team.
            </p>
            <ul className={styles.agentFeatureList}>
              <li> Lead scoring</li>
              <li> Automated follow-ups</li>
              <li> Smart segmentation</li>
            </ul>
          </div>
        </div>
      </section>

            {/* FAQ SECTION - STILL HAVE QUESTIONS? */}
      <section className={styles.faqSection}>
        <h2 className={styles.faqTitle}>Still have Questions?</h2>
        <p className={styles.faqSubtitle}>
          Find answers to common questions about Toxbox.ai
        </p>

        <div className={styles.faqContainer}>
          {/* FAQ 1 */}
          <div className={styles.faqCard}>
            <div className={styles.faqIconWrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <h3 className={styles.faqQuestion}>How does Toxbox.ai work?</h3>
              <p className={styles.faqAnswer}>
                Toxbox.ai uses advanced AI algorithms to automate your sales process. Simply connect your tools, configure your preferences, and let our AI agents handle lead generation, customer engagement, and sales analytics.
              </p>
            </div>
          </div>

          {/* FAQ 2 */}
          <div className={styles.faqCard}>
            <div className={styles.faqIconWrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <h3 className={styles.faqQuestion}>Can I integrate with my existing CRM?</h3>
              <p className={styles.faqAnswer}>
                Yes! Toxbox.ai seamlessly integrates with all major CRM platforms including Salesforce, HubSpot, Pipedrive, and many others. Our one-click integration makes setup quick and easy.
              </p>
            </div>
          </div>

          {/* FAQ 3 */}
          <div className={styles.faqCard}>
            <div className={styles.faqIconWrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <h3 className={styles.faqQuestion}>What kind of support do you offer?</h3>
              <p className={styles.faqAnswer}>
                We provide comprehensive support through email, chat, and phone depending on your plan. Enterprise customers get dedicated account managers and 24/7 priority support.
              </p>
            </div>
          </div>

          {/* FAQ 4 */}
          <div className={styles.faqCard}>
            <div className={styles.faqIconWrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <h3 className={styles.faqQuestion}>Is my data secure?</h3>
              <p className={styles.faqAnswer}>
                Absolutely. We use enterprise-grade encryption, maintain SOC 2 compliance, and follow industry best practices for data security. Your data is always private and protected.
              </p>
            </div>
          </div>

          {/* FAQ 5 */}
          <div className={styles.faqCard}>
            <div className={styles.faqIconWrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <h3 className={styles.faqQuestion}>Can I cancel anytime?</h3>
              <p className={styles.faqAnswer}>
                Yes, you can cancel your subscription at any time. We offer flexible month-to-month billing with no long-term contracts required for our Starter and Professional plans.
              </p>
            </div>
          </div>

          {/* FAQ 6 */}
          <div className={styles.faqCard}>
            <div className={styles.faqIconWrapper}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div>
              <h3 className={styles.faqQuestion}>Do you offer a free trial?</h3>
              <p className={styles.faqAnswer}>
                Yes! We offer a 14-day free trial with full access to all features. No credit card required to start your trial.
              </p>
            </div>
          </div>
        </div>

        {/* FINAL CTA */}
        <div className={styles.faqFinalCta}>
          <p className={styles.faqCtaText}>Didn't find what you're looking for?</p>
          <button className={styles.faqContactBtn}>Contact Support</button>
        </div>
      </section>

    </div>
  );
}

export default SalesMarketing;